/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Delivery_On_Time_RateInputs */

const vi_dashboard_manager_delivery_on_time_rate = /** @type {(inputs: Dashboard_Manager_Delivery_On_Time_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đúng SLA`)
};

/**

* @param {Dashboard_Manager_Delivery_On_Time_RateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_delivery_on_time_rate = /** @type {((inputs?: Dashboard_Manager_Delivery_On_Time_RateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Delivery_On_Time_RateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_delivery_on_time_rate(inputs)
});